var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes, style: _vm.outerStyles },
    [
      _vm.videoSrc
        ? _c("div", { staticClass: "image-sizer", style: _vm.sizerStyles }, [
            _c("video", {
              attrs: {
                poster: _vm.parsedPoster,
                src: _vm.videoSrc,
                loop: _vm.loop,
                playsinline: "",
                autoplay: "",
                muted: ""
              },
              domProps: { muted: true },
              on: {
                ended: function($event) {
                  return _vm.$emit("ended", $event)
                }
              }
            })
          ])
        : _vm.src || _vm.html
        ? _c("div", {
            staticClass: "image-sizer",
            style: _vm.sizerStyles,
            domProps: { innerHTML: _vm._s(_vm.imageTag || "") }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }